/*
* Broadcast Theme
*/

(function() {

  // Atualiza o preço quando o cliente muda de variante
  document.addEventListener('theme:variant:change', function(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    var price     = variant.price;
    var compareAt = variant.compare_at_price;
    var fmt = window.theme && window.theme.formatMoney
      ? function(v) { return window.theme.formatMoney(v, theme.moneyFormat); }
      : function(v) { return (v / 100).toLocaleString('hu-HU') + ' HUF'; };

    document.querySelectorAll('[data-product-price]').forEach(function(el) {
      el.innerHTML = fmt(price);
    });

    document.querySelectorAll('[data-compare-price]').forEach(function(el) {
      if (compareAt && compareAt > price) {
        el.innerHTML = fmt(compareAt);
        var w = el.closest('[data-price-wrapper]');
        if (w) w.classList.add('product__price--sale');
      } else {
        el.innerHTML = '';
      }
    });

    if (compareAt && compareAt > price) {
      var pct = Math.round((1 - price / compareAt) * 100);
      document.querySelectorAll('[data-price-off-amount]').forEach(function(el) {
        el.textContent = pct + '%';
      });
      document.querySelectorAll('[data-price-off-badge]').forEach(function(el) {
        el.removeAttribute('hidden');
      });
    } else {
      document.querySelectorAll('[data-price-off-badge]').forEach(function(el) {
        el.setAttribute('hidden', '');
      });
    }
  });

})();